
<template lang="pug">
#app
  menu-window
  loading-icon
  material-window
  debug-window
  .menu-button(@click="onClick")
    menu-button
  transition(name="fade")
    .show-debug-info(v-if="!isShowDebug" @click="showDebug")
      .show-debug-info__inner
        p
          | open
          br
          | debug
</template>

<script>

import MenuWindow from './MenuWindow'
import MaterialWindow from './MaterialWindow'
import MenuButton from './MenuButton'
import LoadingIcon from './LoadingIcon'
import DebugWindow from './DebugWindow'
import {mapState, mapMutations} from 'Vuex'


export default {
  props:{},
  components: {
    MenuWindow,
    MaterialWindow,
    MenuButton,
    LoadingIcon,
    DebugWindow
  },
  computed: {
    ...mapState('menu', {isShowMenu: 'isShow'}),
    ...mapState('debug', {isShowDebug: 'isShowDebug'})
  },
  methods: {
    ...mapMutations('menu', {showMenu: 'show', hideMenu: 'hide'}),
    ...mapMutations('material', {hideMaterial: 'hide'}),
    ...mapMutations('debug', {showDebug: 'show'}),
    onClick(){
      if(this.isShowMenu){
        this.hideMenu();
      }else{
        this.showMenu();
        this.hideMaterial();
      }
    },
  },
  created () {},
  mounted () {
  },
  data () {
    return {
    }
  },
}
</script>

<style land="stylus">
center-child(){
   display: flex;
   justify-content: center;
   align-items: center;
}
</style>

<style lang="stylus" scoped>
@import '~/css/mixins'
.fade
  &-enter-active,
  &-leave-active
    transition opacity 0.3s ease;
  &-enter,
  &-leave-to
    opacity 0;

a
  display block
.menu-button
  position fixed
  top 20px
  right 20px
  z-index 200

.show-debug-info
  color white
  position fixed
  top 60px
  left 10px
  z-index 99
  width 50px
  height 50px
  border white 1px solid
  color white
  text-align center
  font-size 13px
  cursor pointer
  &__inner
    width 100%
    height 100%
    center-child()
</style>

